import { render, staticRenderFns } from "./SearchSchemeOther.vue?vue&type=template&id=58628158&scoped=true"
import script from "./SearchSchemeOther.vue?vue&type=script&lang=js"
export * from "./SearchSchemeOther.vue?vue&type=script&lang=js"
import style0 from "./SearchSchemeOther.vue?vue&type=style&index=0&id=58628158&prod&scoped=true&lang=css"
import style1 from "./SearchSchemeOther.vue?vue&type=style&index=1&id=58628158&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58628158",
  null
  
)

export default component.exports